import {DataStore, Predicates} from '@aws-amplify/datastore';
import {UserAccount} from 'models';

export const getWithEmail = async (email) => {
    return DataStore.query(UserAccount, (c) => c.emailAddress('eq', email));
};

export const fetchRecordsWithAuthorizingFlag = async () => {
    return DataStore.query(UserAccount, (c) => c.isAuthorizing('eq', 'yes'));
};

export const fetchRecords = async (filter) => {
    return DataStore.query(UserAccount, filter);
};

export const fetch = async (recordId) => {
    return DataStore.query(UserAccount, recordId);
};

export const add = async (payload) => {
    payload.createdAt = new Date().toISOString();
    return DataStore.save(new UserAccount({...payload}));
};

export const update = async (recordId, record) => {
    const original = await DataStore.query(UserAccount, recordId);

    const updated = UserAccount.copyOf(original, (updated) => {
        updated.username = record.username;
        updated.cognitoUserPoolDomain = record.cognitoUserPoolDomain;
        updated.appClientId = record.appClientId;
        updated.description = record.description;
        updated.callbackUrls = record.callbackUrls;
        updated.icaoCode = record.icaoCode;
        updated.cognitoUserPoolId = record.cognitoUserPoolId;
        updated.federatedIdProviders = record.federatedIdProviders;
        updated.firstName = record.firstName;
        updated.lastName = record.lastName;
        updated.emailAddress = record.emailAddress;
        updated.nextcloudIdentityProvider = record.nextcloudIdentityProvider;
        updated.isAuthorizing = record.isAuthorizing;
        updated.isVisible = record.isVisible;
        updated.updatedAt = new Date().toISOString();
    });

    return DataStore.save(updated);
};

export const deleteRecord = async (recordId) => {
    const original = await DataStore.query(UserAccount, recordId);
    return DataStore.delete(original);
};

export const deleteAllRecords = async () => {
    return DataStore.delete(UserAccount, Predicates.ALL);
};
